import { render } from "./Support.vue?vue&type=template&id=7608bce8&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=7608bce8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7608bce8"

export default script